import axios from 'axios';
import store from '../index';

const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
	setting: {},
	enableAgents: false,
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getSetting: state => {
		return state.setting;
	},
};

const actions = {
	// dashboard "Visite del sito": stessi parametri della dashboard vendite (period, year, month, compare...)
	asyncFetchOverview: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}analytics/overview`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	// Microsoft Clarity: scheda Comportamento (stessi parametri del periodo) e lettura subito
	asyncFetchClarity: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}clarity/report`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	asyncSyncClarity: async context =>
		(await axios.post(`${context.rootGetters['settings/getUrl']}clarity/sync`, {}, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })).data.data,
	// statistiche della pagina di un prodotto in una lingua: parametri del periodo + item e lang
	asyncFetchItemOverview: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}analytics/item-overview`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	// card "Statistiche" della modifica prodotto: { item, lang, refresh? } -> ultimi 12 mesi della pagina + vendite
	asyncFetchItemStats: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}analytics/item-stats`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	// sezione "Analytics": visite mensili per pagina di una lingua (lang, sort, page, limit, search)
	asyncFetchPages: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}analytics/pages`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	// stato della scansione delle pagine da Google Analytics: { ready, total, syncing }
	asyncFetchPagesStatus: async context => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}analytics/pages/status`, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	asyncFetchData: async (context, settings) => {
		const { month, year } = settings.filters;
		let url = 'analytics';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						month,
						year,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data;
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchDataItem: async (context, settings) => {
		const { month, year, item, lang } = settings.filters;
		let url = 'analytics/item';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						month,
						year,
						item,
						lang,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data;
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
